import 'Modernizr';
import 'alpinejs';
import Swiper from 'swiper';

window.alpine = {
    heroDrawLine: function(element, xPos, yPos) {
        const dpr = window.devicePixelRatio || 1;
        const canvasParent = document.querySelector(element);
        const canvas = canvasParent.querySelector('.canvas');
        const header = document.querySelector('.header');
        const headerRectangle = header.getBoundingClientRect();
        let canvasWidth = canvasParent.clientWidth;
        let canvasHeight = canvasParent.clientHeight;
        let toX = headerRectangle.left + header.offsetWidth / 2 + window.pageXOffset;  
        let toY = headerRectangle.top + header.offsetHeight / 2 + window.pageYOffset;
        let fromX = window.alpine.getCoordinate(canvasWidth, xPos);
        let fromY = window.alpine.getCoordinate(canvasHeight, yPos);
        
        const ctx = canvas.getContext('2d');
        canvas.width = canvasWidth * dpr;
        canvas.height = canvasHeight * dpr;
        canvas.style.width = canvasWidth + 'px';
        canvas.style.height = canvasHeight + 'px';
        ctx.scale(dpr, dpr);

        ctx.arc(fromX, fromY, 6, 0, 2 * Math.PI, false);
        ctx.fillStyle = '#fff';
        ctx.fill();
        ctx.beginPath();
        ctx.setLineDash([2, 8]);
        ctx.lineWidth = 4;
        ctx.strokeStyle = '#fff';
        ctx.lineCap = "round";
        ctx.moveTo(fromX, fromY);
        ctx.lineTo(toX, toY);
        ctx.stroke();
        ctx.lineWidth = 5;
    },
    getCoordinate: function(pixel, percentage) {
        return pixel / 100 * percentage;
    } 
}

var mySwiper = new Swiper ('.swiper-container', {
    // direction: 'vertical',
    loop: true,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
})